import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organization-users',
  templateUrl: './organization-users.component.html',
  styleUrls: ['./organization-users.component.scss']
})
export class OrganizationUsersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
